import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyTechBridge from './components/WhyTechBridge';
import HowItWorks from './components/HowItWorks';
import AMCSupport from './components/AMCSupport';
import CapabilityStrip from './components/CapabilityStrip';
import ConversionCTA from './components/ConversionCTA';
import Contact from './components/Contact';
import Footer from './components/Footer';
import MobileActionBar from './components/MobileActionBar';

export default function Home() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    const elements = document.querySelectorAll('.animate-on-scroll');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <main className="min-h-screen bg-background-50">
      <Header />
      <Hero />
      <Services />
      <WhyTechBridge />
      <HowItWorks />
      <AMCSupport />
      <CapabilityStrip />
      <ConversionCTA />
      <Contact />
      <Footer />
      <MobileActionBar />
      <div className="md:hidden h-[68px]" aria-hidden="true"></div>
    </main>
  );
}